const VISIBLE = 'js-visible';
const ACTIVE = 'js-active';
const OVERLAY = 'site--backdrop-header';
const PREVENT_SCROLLING = 'body--backdrop-header';
const PHONE_MAX_SCREEN_SIZE = 992;

const ACTIVATION_TIMES = {
    level0: {
        select: 200,
        change: 300,
        deselect: 20
    },
    otherLevels: {
        select: 0,
        change: 100,
        deselect: 20
    }
};

function comparePaths(path1, path2) {
    return path1.length === path2.length && path1.every((value, index) => value === path2[index]);
}

function renderSubpath(subpath, items) {
    if (subpath.length > 0)
        renderNonemptySubpath(subpath[0], subpath.slice(1), items);
    else
        renderEmptySubpath(items);
}

function renderNonemptySubpath(firstId, restSubpath, items) {
    items.forEach(item => {
        if (item.id === firstId) {
            item.title?.classList.add(ACTIVE);
            item.sub?.classList.add(VISIBLE);

            item.title?.classList.toggle(VISIBLE, restSubpath.length === 0);

            renderSubpath(restSubpath, item.children);
            item.sport?.reset();
        }
        else {
            item.title?.classList.remove(VISIBLE);
            item.sub?.classList.remove(VISIBLE);
        }
    });
}

function renderEmptySubpath(items) {
    items.forEach(item => {
        item.title?.classList.add(VISIBLE);

        if (item.sub) {
            item.sub.classList.remove(VISIBLE);
        }
    });
}

function purgeSubpath(subpath, items) {
    if (subpath.length === 0)
        return;

    const item = items.find(i => i.id === subpath[0]);
    if (item) {
        item.title?.classList.remove(ACTIVE);
        item.sport?.deactivate();
    
        purgeSubpath(subpath.slice(1), item.children);
    }
}

let path = [];
const topLevelItems = createL0();
const site = document.getElementsByClassName('site')[0];
const body = document.getElementsByTagName('body')[0];

function render(oldPath) {
    purgeSubpath(oldPath, topLevelItems);
    renderSubpath(path, topLevelItems);

    // The overlay is controlled directly by the "Menu" button on phones.
    if (!isOnPhone()) {
        site?.classList.toggle(OVERLAY, path.length > 0);
        body?.classList.toggle(PREVENT_SCROLLING, path.length > 0);
    }

}

let sportsMenuDisabled = false;

function initMenuDisabled() {
    /**
     * Disabled menu observer
     * 
     */

    const sportsMenuControl = [ ...document.getElementsByClassName('menu__control') ].filter(control => control.dataset.jsFor === 'sports')[0];

    const hpMenuSlider = document.getElementsByClassName('js-hpmenu-wrapper')[0];
    const hpSportMenuObserver = new window.IntersectionObserver(entries => {
        sportsMenuDisabled = entries[0].isIntersecting;
        if(sportsMenuDisabled && !isOnPhone()) {
            sportsMenuControl.disabled = true;
            sportsMenuControl.classList.add('menu-link--active');
        } else {
            sportsMenuControl.disabled = false;
            sportsMenuControl.classList.remove('menu-link--active');
        }
    });

    if (hpMenuSlider)
        hpSportMenuObserver.observe(hpMenuSlider);
}

initMenuDisabled()

window.addEventListener('resize', () => {
    initMenuDisabled()
})


function activateItem(id, level) {
    const oldPath = [ ...path ];
    path = [
        ...path.slice(0, level),
        id
    ];

    if (!comparePaths(path, oldPath))
        render(oldPath);
}

function goBack() {
    const oldPath = [ ...path ];
    path = path.slice(0, path.length - 1);

    render(oldPath);
}

function resetPath() {
    const oldPath = [ ...path ];
    path.length = 0;

    render(oldPath);
}

let hoveredItemIndex = 0;

[ ...document.getElementsByClassName('menu__control') ].forEach(control => {
    control.addEventListener('click', () => {
        activateItem(control.dataset.jsFor, control.dataset.jsLevel);
    });
});

[ ...document.getElementsByClassName('menu__control-back') ].forEach(control => {
    control.addEventListener('click', event => {
        goBack();
        event.stopPropagation();
    });
});

function isOnPhone() {
    return window.innerWidth < PHONE_MAX_SCREEN_SIZE;
}

function getMillisecondsOnHover(level, action) {
    const data = level == 0 ? ACTIVATION_TIMES.level0 : ACTIVATION_TIMES.otherLevels;
    return data[action] ?? 0;
}

[ ...document.getElementsByClassName('menu-sports__title'), ...document.getElementsByClassName('main-menu__title') ].forEach(title => {
    title.addEventListener('mouseenter', () => {
        if (isOnPhone())
            return;

        const titleId = title.dataset.jsFor;
        const titleLevel = title.dataset.jsLevel;

        if (titleId === 'sports' && titleLevel == 0 && sportsMenuDisabled)
            return;

        hoveredItemIndex++;
        const currentIndex = hoveredItemIndex;

        setTimeout(() => {
            if (currentIndex === hoveredItemIndex)
                activateItem(titleId, titleLevel);
        }, getMillisecondsOnHover(titleLevel, path.length <= titleLevel ? 'select' : 'change'));
    });

    title.addEventListener('mouseleave', () => {
        if (isOnPhone())
            return;

        hoveredItemIndex++;
        const currentIndex = hoveredItemIndex;

        // We have to wait for the potential enter event but then we should leave as soon as possible.
        setTimeout(() => {
            if (currentIndex === hoveredItemIndex)
                resetPath();
        }, getMillisecondsOnHover(title.dataset.jsLevel, 'deselect'));
    });
});

[ ...document.getElementsByClassName('menu-sports__sub'), ...document.getElementsByClassName('main-menu__sub') ].forEach(sub => {
    // Increment hover index to cancel leave event
    sub.addEventListener('mouseenter', () => {
        if (isOnPhone())
            return;

        hoveredItemIndex++;
    });

    sub.addEventListener('mouseleave', () => {
        if (isOnPhone())
            return;

        hoveredItemIndex++;
        const currentIndex = hoveredItemIndex;

        // We have to wait for the potential enter event but then we should leave as soon as possible.
        setTimeout(() => {
            if (currentIndex === hoveredItemIndex)
                resetPath();
        }, getMillisecondsOnHover(1, 'deselect'));
    });
});

function createSport(outerSub) {
    const subs = [ ...outerSub.getElementsByClassName('sport-menu__sub') ];
    const controls = [ ...outerSub.getElementsByClassName('sport-menu__control') ];

    const items = subs.map((sub, index) => ({
        sub,
        control: controls[index]
        //isActive: false
    }));

    const sport = {
        items,
        activeItem: null,
        render: function () {
            //this.items.forEach(item => item.sub.classList.toggle(ACTIVE, item.isActive));
            this.items.forEach(item => {
                item.control?.classList.toggle(ACTIVE, item === this.activeItem);
                item.sub?.classList.toggle(VISIBLE, item === this.activeItem);
            });
        },
        reset: function () {
            //this.items.forEach(item => item.isActive = false);
            this.activeItem = this.items[0] ?? null;
            this.render();
        },
        deactivate: function () {
            this.activeItem = null;
            this.render();
        }
    };

    items.forEach(item => item.control.addEventListener('click', () => {
        sport.activeItem = sport.activeItem !== item ? item : null;
        sport.render();
    }));

    return sport;
}

function createL0() {
    const outerItems = [ ...document.getElementsByClassName('main-menu__item') ];

    const items = outerItems.map(outer => {
        const id = outer.dataset.jsId;
        const sub = outer.getElementsByClassName('main-menu__sub')[0];

        return {
            id,
            outer,
            sub,
            title: outer.getElementsByClassName('main-menu__title')[0],
            children: id === 'sports' ? createSports() : [],
            sport: id !== 'sports' && id !== 'brands' ? createSport(sub) : undefined
        };
    });

    return items;
}

function createSports() {
    const outerItems = [ ...document.getElementsByClassName('menu-sports__item') ];

    const items = outerItems.map(outer => {
        const sub = outer.getElementsByClassName('menu-sports__sub')[0];

        return {
            id: outer.dataset.jsId,
            outer,
            sub,
            title: outer.getElementsByClassName('menu-sports__title')[0],
            children: [],
            sport: createSport(sub)
        };
    });

    return items;
}

/**
 * Menu
 */
const mainMenu = document.getElementById('mainMenu');
const hamburger = document.getElementById('mainMenuHamburger');
const mainMenuBtn = document.getElementById('mainMenuBtn');

if (mainMenuBtn && window.location.pathname.includes('cart')) {
    mainMenuBtn.style.display = 'none';
}

if (mainMenu) {
    mainMenu.addEventListener('show.bs.collapse', (evt) => {
        if (evt.target.getAttribute('id') !== 'mainMenu')
            return;

        resetPath();
        hamburger?.classList.add('is-active');
        site?.classList.add(OVERLAY);
        body?.classList.add(PREVENT_SCROLLING);
    });

    mainMenu.addEventListener('hide.bs.collapse', (evt) => {
        if (evt.target.getAttribute('id') !== 'mainMenu')
            return;

        hamburger?.classList.remove('is-active');
        site?.classList.remove(OVERLAY);
        body?.classList.remove(PREVENT_SCROLLING);
    });
}

const backdrop = document.getElementsByClassName('site__backdrop')[0];
const togglerButton = document.getElementsByClassName('header-item--toggler')[0];

backdrop?.addEventListener('click', () => {
    if (hamburger?.classList.contains('is-active'))
        togglerButton.click();
});

render(path);
